import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { getRGBA } from 'utils/color'

const useStyles = makeStyles((theme: Theme) => ({
  containerToDo: {
    maxWidth: '420px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    padding: '16px',
    borderRadius: '0.25rem',
    backgroundColor: `${getRGBA('#EF6C00', 0.08)} !important`,
  },
  containerInitialized: {
    maxWidth: '420px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    padding: '16px',
    borderRadius: '0.25rem',
    backgroundColor: `${getRGBA('#3024E1', 0.08)} !important`,
  },
  containerCompleted: {
    maxWidth: '420px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    padding: '16px',
    borderRadius: '0.25rem',
    backgroundColor: `${getRGBA('#2E7D32', 0.08)} !important`,
  },
}))

export { useStyles }
